<template>
  <div class="width100" :class="['Padding', { inApp: $root.$data.isApp }]">
    <common-title
      :titleName="courseType === 1 ? titleName : titleName2"
      :bcColor="'#F9F9F9'"
      :zIndex="1000"
    >
      <div slot="btnSty">
        <div class="courseBtn" @click="beOverdue" v-if="overdueCourses.length > 0">{{ text }}</div>
      </div>
    </common-title>
    <ul class="myCourse">
      <li v-for="item in courseList" :key="item.id" @click="goDetails(item)">
        <h3 class="ellipsis">
          <i v-if="item.productName.substr(0, 1) == '【'" class="title-special-processing" />{{
            item.productName
          }}
        </h3>
        <p v-if="item.learnProgress">
          已学<span>{{ (item.learnProgress * 100).toFixed(0) }}%</span>
        </p>
        <p v-else>未学习</p>
        <b v-show="item.status === 4">售后中</b>
      </li>
    </ul>
    <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
    <Foot />
    <goToAppVue />
    <commonLoading :loading="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqCourseList } from '@/api/personal';
import EmptyData from '@/components/emptyData/emptyData.vue';
// eslint-disable-next-line import/extensions
import commonLoading from '@/components/commonComponents/CommonLoading';
import Foot from '@/components/foot/privacy.vue';
import goToAppVue from '../../../components/commonComponents/goToApp.vue';

export default {
  components: {
    goToAppVue,
    EmptyData,
    commonLoading,
    Foot,
  },
  data() {
    return {
      courseType: 1, // 1 我的课程  2 过期课程
      titleName: '我的课程',
      titleName2: '过期课程',
      courseList: [],
      overdueCourses: [],
      text: '过期课程',
      listEmpty: false,
      loading: true,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    userInfo: {
      deep: true,
      handler() {
        this.loading = true;
        this.getCourseList();
      },
    },
  },
  created() {},
  mounted() {
    this.loading = true;
    this.getCourseList();
  },
  methods: {
    async getCourseList() {
      // 获取课程信息
      const userId = this.userInfo.id;
      if (userId) {
        const res = await reqCourseList('', [1]);
        if (res.code === 0 && res.data.length > 0) {
          const courseList = res.data.filter(
            (item) => Number(item.status) === 1 || Number(item.status) === 4,
          );
          const overdueCourses = res.data.filter((item) => Number(item.status) === 3);
          this.courseList = courseList; // 课程列表
          this.overdueCourses = overdueCourses; // 过期课程列表
          if (!this.courseList?.length) {
            this.listEmpty = true;
          }
        } else {
          this.listEmpty = true;
        }
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    beOverdue() {
      this.$router.push({
        // 跳过期课程页
        path: '/personalCenter/overdueCourses',
      });
    },
    goDetails(course) {
      // 导学页
      if (course.status === 4) {
        this.$toast('课程正在售后中，暂时不可以进行学习，如有问题请联系客服');
        return;
      }
      const { id } = course;
      this.$router.push({
        path: '/learningGuide',
        query: {
          catalogId: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot {
  bottom: 120px;
}
.courseBtn {
  position: absolute;
  top: 0;
  right: 36px;
  color: #333;
  font-size: 25px;
}
.Padding {
  padding-top: 100px;
  padding-bottom: 109px;
  background: #f9f9f9ff;
  &.inApp {
    padding-top: 0;
  }
}
.myCourse {
  min-height: 73vh;
  margin-top: 36px;
  padding-bottom: 120px;
  li {
    position: relative;
    width: 678px;
    height: 170px;
    margin: 0 auto 22px;
    padding: 36px 36px 0;
    background: #fff;
    border-radius: 14px;
    h3 {
      color: #333;
      font-size: 29px;
      line-height: 40px;
    }
    p {
      margin-top: 22px;
      color: #787878;
      font-size: 25px;
      line-height: 36px;
      span {
        color: #ff6c02;
      }
    }
    > b {
      position: absolute;
      right: 36px;
      bottom: 36px;
      display: inline-block;
      padding: 8px 15px;
      color: #fff;
      font-size: 24px;
      background: #a5a5a5;
      border-radius: 20px;
    }
  }
}
</style>
